<p-dialog
  [modal]="true"
  [style]="{width: '95vw'}"
  [(visible)]="visible"
  [closable]="false"
  [showHeader]="false"
  (onHide)="closeDialog()"
  [draggable]="false"
>
<!-- your-component.component.html -->
<p-toast></p-toast>

<app-document-summary-sidebar
  *ngIf="dialogType === 'document'"
  [sidebarVisible]="sidebarVisible"
  (emitSidebarUpdate)="updateSidebar($event)"
  [summaryData]="summaryData"
  [header]="headerSummary"
  [documentName]="summaryDocumentName"
></app-document-summary-sidebar>

<app-table-summary-sidebar
  *ngIf="dialogType === 'table'"
  [sidebarVisible]="sidebarVisible"
  (emitSidebarUpdate)="updateSidebar($event)"
  [summaryData]="summaryData"
  [header]="headerSummary"
  [documentName]="summaryDocumentName"
  [deltaTable]="deltaTableForSummary"
>
</app-table-summary-sidebar>

<div class="docContainer">
<p-tabView class="custom-tabview" [(activeIndex)]="activeTabIndex">
<button
  type="button"
  (click)="closeDialog()"
  class="tab-close-btn"
  aria-label="Close"
>
  <i class="pi pi-times"></i>
</button>

  <!-- Tables -->

  <p-tabPanel header="Tables" class="pt-0">

  <div>
    <div *ngIf="isloading" class="loadingContainer">
      <app-loader [isLoading]="isloading"></app-loader>
    </div>
    <div class="ngTable" (scroll)="scrollUpdate.next($event)" *ngIf="!isloading">
      <p-table
        #table
        [value]="tablesListByCategory"
        (onRowExpand)="onRowExpand($event)"
        scrollHeight="calc(100vh - 280px)" dataKey="category"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" style="width: 5rem">
            </th>
            <th scope="col" class="nameCol">Category</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
          <tr>
            <td>
              <p-button
                type="button"
                class="expandRowClass"
                pRipple
                [pRowToggler]="rowData"
                [text]="true"
                [rounded]="true"
                [plain]="true"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              ></p-button>
            </td>
            <td
                tooltipPosition="top"
                class="category-clickable"
                (click)="table.toggleRow(rowData)"
                (keydown.enter)="table.toggleRow(rowData)"
              >
                <span>{{ rowData.category }}</span>
              </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-rowData>
          <tr>
            <td colspan="7">
          <p-table [value]="rowData.tables" *ngIf="rowData.tables.length > 0"
            [(selection)]="selectedTables">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" class="checkbox">
                  <p-checkbox
                  [(ngModel)]="rowData.categorySelection"
                  [binary]="true"
                  (onChange)="rowData.categorySelection ? selectCategoryRows(rowData.category, rowData.tables) : deselectCategoryRows(rowData.category)"></p-checkbox>
                </th>
                <th scope="col" style="width: 50%;">Table Name</th>
                <th scope="col">Source</th>
                <th scope="col">About</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-tableData>
              <tr [pSelectableRow]="tableData.tableId">
                <td>
                    <p-tableCheckbox
                      [value]="tableData"
                    ></p-tableCheckbox>
                </td>
                <td style="width: 50%;"> <span class="ellipsis">{{ tableData.tableName }}</span></td>
                <td >{{ tableData.source }}</td>
                <td><button type="button" class="hyperlink" (click)="showAbout(tableData)" (keydown.enter)="showAbout(tableData)">
                  Click here to see data dictionary
                </button></td>
              </tr>
            </ng-template>
          </p-table>
          <div *ngIf="rowData.tables.length === 0" class="flex justify-content-center align-items-center spinnerContainerESG">
            <span class="loaderSpinner mr-2"></span>
          </div>
        </td></tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" class="emptymessage">
          <tr>
            <td colspan="12">
              <div class="noData">No Document Available</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div *ngIf="loadmoreLoading && tablesList.length > 0 && !isloading" class="flexEnd load-more mt-1">
      Loading...
    </div>
  </div>
  </p-tabPanel>

<!-- Documents -->

  <p-tabPanel header="Documents" class="pt-0">
    <div class="esg-documents-toolbar"  *ngIf="!isESGFilterLoading">
      <div class="doc-toolbar-item">
        <span class="doc-toolbar-item-header">Tags</span>
        <p-multiSelect
              [options]="ESGtagsList"
              [(ngModel)]="selectedESGTags"
              placeholder="Select Tags"
              optionLabel="tag"
              (onPanelShow)="onMultiSelectOpen()"
              (onChange)="updateTagsDropDownCount()"
              class="custom-multiSelect mt-1"
              [selectedItemsLabel]="selectedTagsLabel"
              [maxSelectedLabels]="0"
          >
          </p-multiSelect>
        
      </div>
      <div class="doc-toolbar-item">
        <span class="doc-toolbar-item-header">Source Type</span>
        <p-multiSelect
          [options]="ESGSourcesList"
          [(ngModel)]="selectedESGSourceType"
          placeholder="Select Source"
          optionLabel="sourceType"
          (onPanelShow)="onMultiSelectOpen()"
          (onChange)="updateFiltersSource()"
          (onClear)="updateFiltersSource(true)"
          class="custom-multiSelect mt-1"
          [selectedItemsLabel]="selectedSourceLabel"
          [maxSelectedLabels]="0"
        >
        </p-multiSelect>
      </div>
      <div class="doc-toolbar-item p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
            pInputText
            class="searchInput p-inputtext pr-5"
            type="text"
            (keydown)="this.searchTextUpdate.next($event)"
            [(ngModel)]="searchText"
            placeholder="Search Documents"
        />
        <button
            type="button"
            *ngIf="searchText?.length > 0"
            (click)="searchText = ''; isESGFilterLoading=true;  updateFiltersSource()"
            class="searchCancel"
        >
            <i class="pi pi-times cursor"></i>
        </button>
      </div>
    </div>
    <div *ngIf="isESGFilterLoading" class="loadingContainer">
      <app-loader [isLoading]="isESGFilterLoading"></app-loader>
    </div>
    <div class="documents-scroll-wrapper">
    <div class="ngTable" (scroll)="scrollUpdate.next($event)" *ngIf="!isESGFilterLoading">
    <p-table [value]="ESGDocumentNameList" [(selection)]="selectedESGDocumentsList">
        <ng-template pTemplate="header">
            <tr>
                <th scope="col" class="checkbox">
                  <p-tableHeaderCheckbox (click)="updateFiltersDocsBatch()" (keydown.enter)="updateFiltersDocsBatch()"></p-tableHeaderCheckbox>
                </th>
                <th scope="col" style="width: 40%;">Name</th>
                <th scope="col">Source</th>
                <th scope="col">Summary</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-document>
            <tr>
                <td>
                  <p-tableCheckbox [value]="document" (click)="updateFiltersDocuments()" (keydown.enter)="updateFiltersDocuments()"></p-tableCheckbox>
                </td>
                <td>{{ document.documentName }}</td>
                <td>{{ document.sourceType }}</td>
                <td><button type="button" class="hyperlink" (click)="showESGSUmmary(document)" (keydown.enter)="showESGSUmmary(document)">
                  Click here to see summary
                </button></td>
            </tr>
        </ng-template>
    </p-table></div>
    </div>
  </p-tabPanel>
</p-tabView>
</div>
<ng-template pTemplate="footer">
  <div *ngIf="activeTabIndex === 0 || activeTabIndex === 1" class="sticky-footer-btn flex justify-content-between mt-1" >
    <div class="alertText" ><span *ngIf="checkMultipleSourcesSelection()">* Please select tables from a single source only.</span></div>
    <button
      type="button"
      (click)="checkChatDocs()"
      class="p-button p-button-primary btnPadding"
      [disabled]="
        (activeTabIndex === 0 && (selectedTables.length === 0 )) ||
        (activeTabIndex === 1 && !(selectedESGSourceType?.length > 0 || selectedESGTags?.length > 0 || selectedESGDocumentsList?.length > 0)) || checkMultipleSourcesSelection()
      "
    >
      <span *ngIf="chatwithDocs" class="loaderSpinnerWhite mr-2"></span>
      Chat with Tables/Documents
    </button>
  </div>
  </ng-template>
</p-dialog>
